export const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
const LONG_MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

const num = (v) => (v === null || v === undefined || Number.isNaN(Number(v)) ? null : Number(v));
const money = (d) => (v) => (num(v) === null ? "—" : `$${num(v).toLocaleString("en-AU", { minimumFractionDigits: d, maximumFractionDigits: d })}`);
export const fmtPct = (v) => (num(v) === null ? "—" : `${(num(v) * 100).toFixed(1)}%`);
export const fmtMoney = money(2);
export const fmtMoney0 = money(2);
export const fmtDec = (v) => (num(v) === null ? "—" : num(v).toFixed(1));
export const fmtInt = (v) => (num(v) === null ? "—" : Math.round(num(v)).toLocaleString("en-AU"));

export const METRICS = [
  { key: "occ", label: "Occupancy", fmt: fmtPct, axis: (v) => `${Math.round(v * 100)}%` },
  { key: "rev", label: "Revenue", fmt: fmtMoney0, axis: (v) => `$${Math.round(v / 1000)}k` },
  { key: "adr", label: "ADR", fmt: fmtMoney, axis: (v) => `$${Math.round(v)}` },
  { key: "revpar", label: "RevPAR", fmt: fmtMoney, axis: (v) => `$${Math.round(v)}` },
  { key: "alos", label: "ALOS", fmt: fmtDec, axis: (v) => Number(v).toFixed(1) },
  { key: "departs", label: "Departure Cleans", fmt: fmtInt, axis: (v) => Math.round(v) },
];

export const PERF_METRICS = METRICS;
export const YEAR_COLORS = ["#cbd5e1", "#f59e0b", "#10b981", "#8b5cf6", "#0284c7", "#ef4444", "#14b8a6", "#64748b"];
// Fixed colour per calendar year everywhere (2026 = blue, 2025 = amber, ...)
const YEAR_PALETTE = ["#0284c7", "#f59e0b", "#10b981", "#8b5cf6", "#ef4444", "#14b8a6", "#64748b", "#ec4899", "#a16207"];
export const yearColor = (y) => { const n = YEAR_PALETTE.length; return YEAR_PALETTE[(((2026 - Number(y)) % n) + n) % n]; };

export const TABLE_COLS = [
  { key: "occ", label: "Occupancy", fmt: fmtPct },
  { key: "rev", label: "Gross Rev", fmt: fmtMoney },
  { key: "adr", label: "ADR", fmt: fmtMoney },
  { key: "revpar", label: "RevPAR", fmt: fmtMoney },
  { key: "alos", label: "ALS", fmt: fmtDec },
  { key: "departs", label: "# Departs", fmt: fmtInt },
];

export const monthLabel = (m) => (m ? `${MONTHS[Number(m.slice(5, 7)) - 1]} ${m.slice(0, 4)}` : "");
export const monthShort = (m) => (m ? MONTHS[Number(m.slice(5, 7)) - 1] : "");
export const fmtDmy = (d) => (d ? `${d.slice(8, 10)}/${d.slice(5, 7)}/${d.slice(0, 4)}` : "—");
export const fmtLong = (d) => (d ? `${Number(d.slice(8, 10))} ${LONG_MONTHS[Number(d.slice(5, 7)) - 1]} ${d.slice(0, 4)}` : "");
export const lyBasisText = (d) => (d.ly_date ? fmtLong(d.ly_date) : d.ly_basis === "finals" ? "last year's final figures (no upload from this time last year)" : "no upload found");

export const fmtShortDate = (d) => (d ? `${Number(d.slice(8, 10))} ${MONTHS[Number(d.slice(5, 7)) - 1]} ${d.slice(0, 4)}` : "");

export const SERIES = [
  { key: "ty", color: (d) => yearColor(d.report_date.slice(0, 4)), label: (d) => `${d.report_date.slice(0, 4)} – as at ${fmtShortDate(d.report_date)}` },
  { key: "ly", color: (d) => yearColor(d.ly_date ? d.ly_date.slice(0, 4) : Number(d.report_date.slice(0, 4)) - 1), label: (d) => (d.ly_date ? `${d.ly_date.slice(0, 4)} – as at ${fmtShortDate(d.ly_date)}` : "Same week last year") },
  { key: "ly_final", color: (d) => `${yearColor(Number(d.report_date.slice(0, 4)) - 1)}80`, label: (d) => `${Number(d.report_date.slice(0, 4)) - 1} Final` },
  { key: "bench", color: (d) => yearColor(d.benchmark_year), label: (d) => (d.bench_date ? `${d.benchmark_year} – as at ${fmtShortDate(d.bench_date)}` : `${d.benchmark_year}`) },
];
